import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../../services/subscription.service';
import { TokenService } from '../../services/token.service';
import { UnsubscribeResponse } from '../../interfaces/subscription.interface';

type ResubscribeStatus = 'loading' | 'resubscribed' | 'error';

@Component({
  selector: 'app-resubscribe-page',
  templateUrl: './resubscribe-page.component.html',
  styleUrls: ['./resubscribe-page.component.scss'],
})
export class ResubscribePageComponent implements OnInit {
  public status: ResubscribeStatus = 'loading';
  public token: string | null = null;

  constructor(
    private readonly subscriptionService: SubscriptionService,
    private readonly tokenService: TokenService,
    private readonly route: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    // Prefer token from query params when navigated via routerLink
    const qpToken = this.route.snapshot.queryParamMap.get('token');
    const token = qpToken ?? this.tokenService.getTokenFromLocation('token');

    // expose token so templates can link to unsubscribe with it
    this.token = token;

    if (!token) {
      this.status = 'error';
      return;
    }

    this.subscriptionService.unsubscribe(token, true).subscribe({
      error: () => {
        this.status = 'error';
      },
      next: (response: UnsubscribeResponse) => {
        this.handleResponse(response);
      },
    });
  }

  private handleResponse(response: UnsubscribeResponse | null): void {
    if (!response || !response.success) {
      this.status = 'error';
    } else {
      this.status = 'resubscribed';
    }
  }
}


